import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .PanelTrigger': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        border: '2px solid #ffffff',
        borderRadius: 20,
        padding: '4px 20px',
        width: '100%',

        '.text': {
            color: '#ffffff',
            display: 'block',
            flexGrow: 1,
            fontSize: toRem(16),
            marginRight: toRem(20),
            textAlign: 'left'
        },

        '.icon': {
            width: 16,
            paddingTop: 6
        },

        [theme.breakpoints.between('md', 'lg')]: {
            width: '32%',
            float: 'left'
        },

        [theme.breakpoints.up('lg')]: {
            display: 'none'
        }
    },

    '& .MobilePanel': {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: theme.colors.blueDark,
        zIndex: 1000,
        overflow: 'auto',

        [theme.breakpoints.up('lg')]: {
            display: 'none'
        }
    },

    '& .MobilePanel--header': {
        textAlign: 'center',
        padding: 30,
        position: 'sticky',
        zIndex: 1010,
        background: theme.colors.blueDark,
        top: 0,
        left: 0,

        button: {
            position: 'absolute',
            top: 27,
            right: 30
        },

        span: {
            textTransform: 'uppercase',
            fontSize: toRem(12),
            fontWeight: theme.typography.fontWeight.medium,
            letterSpacing: 1,
            display: 'block'
        }
    },

    '& .MobilePanel--button': {
        position: 'sticky',
        margin: 'auto auto 0 auto',
        minWidth: 320,
        width: '100%',
        padding: '15px 13px 10px 13px',
        zIndex: 1010,
        bottom: 0,
        left: 0,
        background: theme.colors.blueDark,

        button: {
            width: '100%'
        }
    },

    '& .DesktopPanel': {
        display: 'none',

        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            background: theme.colors.blueLight,
            borderRadius: 4
        }
    },

    '& .DesktopPanelWrap': {
        [theme.breakpoints.up('lg')]: {
            left: '0',
            transform: 'translateX(0)',
            position: 'relative',
            zIndex: 99
        }
    },

    // Sticky Panel
    [theme.breakpoints.up('lg')]: {
        minHeight: 101,

        '&.isSticky': {
            '& .DesktopPanel': {
                background: 'none',
                maxWidth: 1600,
                margin: '0 auto'
            },

            '& .DesktopPanelWrap': {
                position: 'fixed',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100%',
                padding: '0 40px',
                background:
                    'linear-gradient(0deg, rgba(0, 53, 79, 0.85), rgba(0, 53, 79, 0.85)), rgba(81, 131, 155, 0.1)',
                backdropFilter: 'blur(200px)',
                zIndex: 99,
                transition: 'width 0.5s ease, left 0.5s ease, transform 0.5s ease'
            },

            '& .FilterTrigger': {
                paddingTop: 20,
                paddingBottom: 20
            },

            '& .Option': {
                background: 'rgba(0, 53, 79, 0.95)'
            }
        }
    },

    [theme.breakpoints.up('xl')]: {
        minHeight: 161
    }
})

export default style
